import React from "react";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const SolveActivityButton = (props) => {
    const { readOnly, activityData, onClick } = props;

    const color = useSelector(getAppColor);

    if (readOnly) return null;

    return (
        <Button variant="contained" className="whiteText" style={{ background: color, border: 0 }} onClick={onClick}>
            {getLocalizedString("solve")} {getLocalizedString("attempt")} {activityData.currentAttempt}{" "}
            {getLocalizedString("of")} {activityData.attempts}
        </Button>
    );
};

export default SolveActivityButton;
